import {
  ComplianceItem,
  ComplianceReport,
  ComplianceReportSection,
  ComplianceRentalType,
  EligibilityVerdict,
} from 'src/models/compliance.model';

export interface FilteredComplianceReport {
  eligibility: EligibilityVerdict | null;
  sections: ComplianceReportSection[];
}

export function itemMatchesRental(item: ComplianceItem, rentalType: ComplianceRentalType): boolean {
  const appliesTo = (item.applies_to ?? 'both').toString().toLowerCase();
  const suppressed = item.suppressed_for_rental_types?.some(
    (r) => r?.toString().toUpperCase() === rentalType,
  );
  if (suppressed) {
    return false;
  }
  return appliesTo === 'both' || appliesTo === rentalType.toLowerCase();
}

export function pickEligibility(
  report: ComplianceReport,
  rentalType: ComplianceRentalType,
): EligibilityVerdict | null {
  return (
    report.eligibility?.find(
      (verdict) => verdict?.rental_type?.toString().toUpperCase() === rentalType,
    ) ?? null
  );
}

export function filterReportForRental(
  report: ComplianceReport,
  rentalType: ComplianceRentalType,
): FilteredComplianceReport {
  const eligibility = pickEligibility(report, rentalType);
  const isProhibited = eligibility?.status === 'prohibited';

  const sections = (report.sections ?? [])
    .map((section) => ({
      ...section,
      items: (section.items ?? []).filter((item) => itemMatchesRental(item, rentalType)),
    }))
    .filter((section) => {
      if (isProhibited) {
        return section.id === 'blockers' && section.items.length > 0;
      }
      return section.items.length > 0;
    });

  return { eligibility, sections };
}
